// Timezone math for Projects scheduling, using only Intl (no dependency).
// "Start Date" means the service starts at 00:00:00 on that date, in the
// customer's country timezone. "End Date" means the service ends at 00:00:00
// on the day AFTER that date, in the same timezone.

function getOffsetMs(date, timeZone) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const parts = dtf.formatToParts(date).reduce((acc, p) => {
    acc[p.type] = p.value;
    return acc;
  }, {});
  const asUtc = Date.UTC(
    Number(parts.year), Number(parts.month) - 1, Number(parts.day),
    Number(parts.hour), Number(parts.minute), Number(parts.second)
  );
  return asUtc - date.getTime();
}

/** UTC instant of 00:00:00 on `dateStr` ('YYYY-MM-DD') in the given IANA timeZone. */
export function zonedMidnightToUtc(dateStr, timeZone) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const target = Date.UTC(y, m - 1, d, 0, 0, 0);
  let guess = new Date(target);
  for (let i = 0; i < 2; i++) {
    const offset = getOffsetMs(guess, timeZone);
    guess = new Date(target - offset);
  }
  return guess;
}

export function startInstantUtc(startDateStr, timeZone) {
  return zonedMidnightToUtc(startDateStr, timeZone);
}

export function endInstantUtc(endDateStr, timeZone) {
  const midnight = zonedMidnightToUtc(endDateStr, timeZone);
  return new Date(midnight.getTime() + 24 * 60 * 60 * 1000);
}

export function computeStatus(startInstant, endInstant, now = new Date()) {
  if (now.getTime() >= endInstant.getTime()) return 'expired';
  if (now.getTime() < startInstant.getTime()) return 'pending';
  return 'active';
}

/**
 * Validates and computes scheduling fields for a project.
 * Returns { error } or { startInstant, endInstant, status }.
 */
export function evaluateSchedule(startDateStr, endDateStr, timeZone, now = new Date()) {
  if (endDateStr < startDateStr) {
    return { error: 'Error : End date is before Start date.' };
  }
  const startInstant = startInstantUtc(startDateStr, timeZone);
  const endInstant = endInstantUtc(endDateStr, timeZone);
  if (now.getTime() >= endInstant.getTime()) {
    return { error: 'Error : End date is in the past.' };
  }
  return { startInstant, endInstant, status: computeStatus(startInstant, endInstant, now) };
}
